import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col, Modal, Input as AntInput, message } from 'antd';
import classNames from 'classnames';
import { FilePdfTwoTone, CarOutlined, HistoryOutlined, FilePdfOutlined } from '@ant-design/icons';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell, ResponsiveContainer } from 'recharts';
import { Input, Form, Button, Table, Page, ContentWrapper, DatePicker, Select, Statistic, RangePicker, Loading, IconDelete, FooterToolbar } from '~/components';
import { FrequenciaService, PrincipalService, RelatorioService, UserService } from '~/services';
import { focusField } from '~/utils/functions';
import { decimalPlace, decimalValue } from '~/utils';
import { actions, colors } from '~/options';
import './FrotaPage.less';

class FrotaPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.rowColor = [
      { title: 'Atrasado', color: colors.volcano, predicate: item => item.situacao === 'ATRASADO' },
      { title: 'Baixado', color: colors.polarGreen, predicate: item => item.situacao === 'BAIXADO' },
      { title: 'Vence hoje', color: colors.sunriseYellow, predicate: item => item.situacao === 'VENCE HOJE' },
    ];

    this.state = {
      comboEmpresa: [],
      isLoadingContato: false,
      isLoadingHistoricoPlaca: true,
      isLoadingHistorico: false,
      isLoadingVeiculo: false,
      isLoadingPDF: false,
      dataItemsContato: [],
      historicoPlaca: '',
      historicoDataInicial: '',
      historicoDataFinal: '',
      historicoMedia: ' ',
      activeTab: 'historico',
      itensHistorico: [],
      itensVeiculo: [],
      selectedItemHistorico: {},
      selectedItemVeiculo: {},
      dadosAbastecimento: [],
      ticks: [0, 250, 500, 750, 1000],
      actionVeiculo: actions.idle,
    };
  }

  componentDidMount() {
    this.buscarContato('FROTA');
    this.handleSearchHistoricoPlaca(true);
    UserService.fetchEmpresas(comboEmpresa => this.setState({ comboEmpresa }));
    focusField(this.searchInputHistorico);
  }

  buscarContato = arquivo => {
    this.setState({ isLoadingContato: true }, () => {
      PrincipalService.getAllContato(
        arquivo,
        response =>
          this.setState({ dataItemsContato: response.map(item => ({ ...item, zap: item.telefone.replace(/[^0-9]/g, '') })), isLoadingContato: false }),
        () => this.setState({ dataItemsContato: [], isLoadingContato: false })
      );
    });
  };

  disabledDate = current => {
    return current && current > moment().endOf('day');
  };

  onChangeRangePicker = (dataIni, dataFim) => {
    this.setState({ historicoDataInicial: dataIni, historicoDataFinal: dataFim }, () => this.handleSearchHistoricoPlaca());
  };

  onChangePlaca = placa => {
    this.setState({ historicoPlaca: placa }, () => this.handleSearchHistoricoPlaca());
  };

  // HISTÓRICO
  handleSearchHistoricoPlaca = (buscar = false) => {
    const { historicoPlaca, historicoDataInicial, historicoDataFinal } = this.state;

    if (buscar || (historicoPlaca !== '' && historicoDataInicial !== '' && historicoDataFinal !== '')) {
      this.setState({ isLoadingHistoricoPlaca: true });

      const placa = buscar ? '' : historicoPlaca;
      const dataIni = buscar
        ? moment()
            .add(-30, 'day')
            .format('YYYYMMDD')
        : historicoDataInicial;
      const dataFim = buscar
        ? moment()
            .add(-1, 'day')
            .format('YYYYMMDD')
        : historicoDataFinal;

      FrequenciaService.getHistoricoResumo(
        { placa, data_inicial: dataIni, data_final: dataFim },
        response => {
          this.setState(
            {
              dadosAbastecimento: response.itens.slice(0, 7),
              isLoadingHistoricoPlaca: false,
              historicoMedia: response.media ? `${decimalPlace(response.media, 2)} KM / L` : '',
            },
            () => {
              const { dadosAbastecimento } = this.state;
              let ticks = [0];

              if (!dadosAbastecimento || dadosAbastecimento.length === 0) {
                ticks = [0, 250, 500, 750, 1000];
              }

              const maxLitros = Math.max(...dadosAbastecimento.map(item => parseFloat(item.litros || 0)));
              const roundedMax = Math.ceil(maxLitros / 100) * 100;
              const step = roundedMax / 4;

              for (let i = 1; i <= 4; i += 1) {
                ticks.push(Math.round(i * step));
              }

              this.setState({ ticks });
            }
          );
        },
        () => this.setState({ isLoadingHistoricoPlaca: false })
      );
    }
  };

  handleSearchHistorico = values => {
    /*
    if (moment(values.data_final).diff(values.data_inicial, 'days') > 31) {
      Modal.error({
        title: 'Histórico',
        content: 'Não é possível buscar um período maior que o selecionado',
        centered: true,
      });
      return;
    }
    */

    this.setState({ isLoadingHistorico: true }, () => {
      FrequenciaService.getAllHistorico(
        values,
        itensHistorico => this.setState({ itensHistorico, isLoadingHistorico: false }, () => focusField(this.searchInputHistorico)),
        () => this.setState({ isLoadingHistorico: false })
      );
    });
  };

  imprimirCupom = (record, tipo = 'pdf') => {
    this.setState({ isLoadingPDF: true }, () => {
      FrequenciaService.consultarCupom({ ...record, retorno: tipo }, response => {
        this.setState({ isLoadingPDF: false });

        if (response.toString().indexOf(' encontrado') === -1) {
          window.open(`${process.env.REACT_APP_URL}/${response.toString()}`, '_blank');
        } else {
          Modal.error({ content: response.toString(), title: 'Consulta Cupom', centered: true });
        }
      });
    });
  };

  imprimirNota = record => {
    this.setState({ isLoadingPDF: true }, () => {
      const values = [];
      values.push({ nome_campo: 'codigo', valor: record.idt });
      values.push({ nome_campo: 'chave', valor: record.chave });
      values.push({ nome_campo: 'webnfe3', valor: 'S' });
      values.push({
        nome_campo: 'periodo',
        valor: `20${record.chave.substr(2, 4)}`,
      });

      RelatorioService.getChamaRelatorio(
        values,
        'ServletDanfe',
        'Nota Fiscal',
        () => this.setState({ isLoadingPDF: false }),
        () => this.setState({ isLoadingPDF: false })
      );
    });
  };

  // VEÍCULO
  handleSearchVeiculo = values => {
    this.setState({ isLoadingVeiculo: true, actionVeiculo: actions.idle, selectedItemVeiculo: {} }, () => {
      FrequenciaService.getAllVeiculo(
        values,
        itensVeiculo => this.setState({ itensVeiculo, isLoadingVeiculo: false }, () => focusField(this.searchInputVeiculo)),
        () => this.setState({ isLoadingVeiculo: false })
      );
    });
  };

  handleSelectVeiculo = (record, action) => {
    if (action.id !== 'idle') {
      this.saveApiVeiculo.setValues({ ...record });
      this.setState({ selectedItemVeiculo: record });
    } else {
      this.saveApiVeiculo.reset();
      this.setState({ selectedItemVeiculo: {} });
    }
  };

  handleEditVeiculo = action => {
    if (action.id === 'insert') {
      this.saveApiVeiculo.reset();
    }

    this.setState({ actionVeiculo: action }, () => focusField(this.saveInputVeiculo));
  };

  onEditVeiculo = (cancel = false) => {
    const { actionVeiculo } = this.state;
    let { selectedItemVeiculo } = this.state;

    if (cancel) {
      this.handleSelectVeiculo(selectedItemVeiculo, actionVeiculo);
    } else {
      selectedItemVeiculo = {};
      this.searchApi.submitForm();
    }

    this.setState({ actionVeiculo: actions.idle });
  };

  handleSaveVeiculo = values => {
    const { actionVeiculo, selectedItemVeiculo } = this.state;
    let selected = {};

    this.setState({ isLoadingVeiculo: true });

    if (actionVeiculo.id === 'update') {
      selected = selectedItemVeiculo;
    }

    FrequenciaService.salvarVeiculo(
      { ...selected, ...values },
      response => {
        if (response.erro) {
          this.setState({ isLoadingVeiculo: false });
          Modal.error({
            content: response.msg,
            title: 'Veículo - Erro',
            centered: true,
            width: '550px',
          });
        } else {
          message.success('Veículo salvo com sucesso!', 4);
          this.searchApiVeiculo.reset();
          this.searchApiVeiculo.setValues({ placa: response.placa });
          this.searchApiVeiculo.submitForm();
        }
      },
      response => {
        this.setState({ isLoadingVeiculo: false });
        Modal.error({
          content: response.msg,
          title: 'Veículo - Erro',
          centered: true,
          width: '500px',
        });
      }
    );
  };

  handleDeleteVeiculo = record => {
    this.setState({ isLoadingVeiculo: true }, () => {
      FrequenciaService.excluirVeiculo(
        record,
        () => {
          message.success('Veículo excluído com sucesso!', 4);
          this.searchApiVeiculo.submitForm();
        },
        () => {
          message.error('ocorreu um erro ao exclui o veículo. Tente novamente ou contate o setor responsável.', 4);
          this.setState({ isLoadingVeiculo: false });
        }
      );
    });
  };

  // GRÁFICO
  renderCustomBarShape = props => {
    const { x, y, width, height, value } = props;
    const radius = 5;

    return (
      <g>
        <rect x={x} y={y} width={width} height={height} fill="#8884d8" rx={radius} ry={radius} />
        <text x={x + width / 2} y={y + height / 2} fill="#fff" textAnchor="middle" dominantBaseline="middle" fontSize={12}>
          {value}
        </text>
      </g>
    );
  };

  TriangleBar = props => {
    const { fill, x, y, width, height } = props;

    return <path d={this.getPath(x, y, width, height)} stroke="none" fill={fill} />;
  };

  getPath = (x, y, width, height) => {
    return `M${x},${y + height}C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3}
    ${x + width / 2}, ${y}
    C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${x + width}, ${y + height}
    Z`;
  };

  render() {
    const { tabId } = this.props;
    const {
      comboEmpresa,
      isLoadingContato,
      isLoadingHistorico,
      isLoadingHistoricoPlaca,
      isLoadingVeiculo,
      isLoadingPDF,
      dataItemsContato,
      historicoMedia,
      activeTab,
      itensHistorico,
      itensVeiculo,
      selectedItemHistorico,
      selectedItemVeiculo,
      ticks,
      dadosAbastecimento,
      actionVeiculo,
    } = this.state;
    const colorsBars = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', 'red', 'purple'];
    const isIdle = !isLoadingVeiculo && actionVeiculo.id === 'idle';

    return (
      <>
        <div className="conteudo-box frota">
          <div className="form borda">
            <Page tabbed tabId={tabId} activeKey={activeTab} onChange={activeKey => this.setState({ activeTab: activeKey })}>
              {/* HISTÓRICO */}
              <Page.TabPane key="historico" tab="Histórico" icon={<HistoryOutlined />}>
                <Form getApi={api => (this.searchApiHistorico = api)} onSubmit={this.handleSearchHistorico}>
                  <ContentWrapper type="search">
                    <Row gutter={4}>
                      <Col md={12}>
                        <Select field="origem" label="Empresa" dataSource={comboEmpresa} allowClear disabled={isLoadingHistorico} />
                      </Col>
                      <Col md={3}>
                        <Input
                          field="placa"
                          label="Placa"
                          disabled={isLoadingHistorico}
                          type="placa"
                          allowClear
                          forwardedRef={ref => (this.searchInputHistorico = ref)}
                        />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_inicial" label="Data Inicial" required today disabled={isLoadingHistorico} disabledDate={this.disabledDate} />
                      </Col>
                      <Col md={3}>
                        <DatePicker field="data_final" label="Data Final" required today disabled={isLoadingHistorico} disabledDate={this.disabledDate} />
                      </Col>
                      <Col md={3}>
                        <Button.Search loading={isLoadingHistorico} />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>
                <Table
                  rowKey="idt"
                  dataSource={itensHistorico}
                  loading={isLoadingHistorico}
                  record={selectedItemHistorico}
                  onRecordChange={record => this.setState({ selectedItemHistorico: record })}
                  height={window.innerHeight}
                >
                  <Table.Column width="10%" title="Data" dataIndex="emissao" type="date" />
                  <Table.Column width="15%" title="Nota / Cupom" dataIndex="nota_cupom" align="center" />
                  <Table.Column width="15%" title="Tipo" dataIndex="tipo" align="center" />
                  <Table.Column width="30%" title="Empresa" dataIndex="nome_empresa" />
                  <Table.Column width="10%" title="Placa" dataIndex="placa" align="center" />
                  <Table.Column width="10%" title="Valor (R$)" dataIndex="valor" type="currency" />
                  <Table.Column width="10%" title="Litros" dataIndex="quantidade" type="currency" />
                  <Table.Column width="15%" title="Motorista" dataIndex="motorista" />
                  <Table.Column width="10%" title="Odômetro" dataIndex="odometro" align="center" />
                  <Table.Column
                    title="Ações"
                    dataIndex="actions"
                    width="10%"
                    align="center"
                    exporter={false}
                    sorter={false}
                    render={(text, record) => (
                      <>
                        {record.tipo === 'NF-e' ? (
                          <FilePdfOutlined
                            onClick={() => this.imprimirNota(record)}
                            title="Imprimir Nota"
                            className={classNames(isLoadingPDF ? 'icon-disabled' : '', 'icon-table-margin')}
                          />
                        ) : (
                          <FilePdfTwoTone
                            onClick={() => this.imprimirCupom(record)}
                            title="Imprimir Cupom"
                            twoToneColor="#cc0000"
                            className={classNames(isLoadingPDF ? 'icon-disabled' : '', 'icon-table-margin')}
                          />
                        )}
                      </>
                    )}
                  />
                </Table>
                <ContentWrapper type="header">
                  <Row>
                    <Col md={9} />
                    <Col md={6} style={{ textAlign: 'center' }}>
                      <Statistic
                        style={{ textAlign: 'center' }}
                        title="Valor Total (R$)"
                        value={decimalValue(
                          itensHistorico.reduce((previous, current) => parseFloat(current.valor || 0) + previous, 0),
                          2
                        )}
                        color="#3f8600"
                      />
                    </Col>
                  </Row>
                </ContentWrapper>
              </Page.TabPane>

              {/* VEÍCULO */}
              <Page.TabPane key="veiculo" tab="Veículo" icon={<CarOutlined />}>
                <Form getApi={api => (this.searchApiVeiculo = api)} onSubmit={this.handleSearchVeiculo}>
                  <ContentWrapper type="search">
                    <Row gutter={4}>
                      <Col md={18}>
                        <Input field="descricao" label="Descrição" allowClear disabled={isLoadingVeiculo} />
                      </Col>
                      <Col md={3}>
                        <Input
                          field="placa"
                          label="Placa"
                          disabled={isLoadingVeiculo}
                          type="placa"
                          allowClear
                          forwardedRef={ref => (this.searchInputVeiculo = ref)}
                        />
                      </Col>
                      <Col md={3}>
                        <Button.Search loading={isLoadingVeiculo} />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>
                <Table
                  dataSource={itensVeiculo}
                  rowKey="placa"
                  loading={isLoadingVeiculo}
                  record={selectedItemVeiculo}
                  onRecordChange={record => this.handleSelectVeiculo(record, actionVeiculo)}
                >
                  <Table.Column width="15%" title="Placa" dataIndex="placa" align="center" />
                  <Table.Column width="80%" title="Descrição" dataIndex="descricao" />
                  <Table.Column
                    width="5%"
                    title="Ações"
                    dataIndex="actions"
                    align="center"
                    exporter={false}
                    sorter={false}
                    render={(text, record) => (
                      <>
                        <IconDelete validate={{ prefix: 'o' }} prefix="o veículo" onClick={() => this.handleDeleteVeiculo(record)} />
                      </>
                    )}
                  />
                </Table>

                <Form getApi={api => (this.saveApiVeiculo = api)} onSubmit={this.handleSaveVeiculo}>
                  <ContentWrapper type="header">
                    <Row gutter={4}>
                      <Col md={21}>
                        <Input
                          field="descricao"
                          label="Descrição"
                          disabled={isIdle || isLoadingVeiculo}
                          required
                          forwardedRef={ref => (this.saveInputVeiculo = ref)}
                        />
                      </Col>
                      <Col md={3}>
                        <Input field="placa" label="Placa" disabled={isIdle || isLoadingVeiculo} type="alfaNumerico" required />
                      </Col>
                    </Row>
                  </ContentWrapper>
                </Form>
              </Page.TabPane>
            </Page>
            <FooterToolbar
              style={{ display: activeTab === 'veiculo' ? 'block' : 'none' }}
              left={
                <>
                  <Button.Insert disabled={!isIdle} onClick={() => this.handleEditVeiculo(actions.insert)} />
                  <Button.Update disabled={!isIdle} onClick={() => this.handleEditVeiculo(actions.update)} />
                </>
              }
              right={
                <>
                  <Button.Cancel disabled={isIdle || isLoadingVeiculo} onClick={() => this.onEditVeiculo(true)} />
                  <Button.Save disabled={isIdle || isLoadingVeiculo} onClick={() => this.saveApiVeiculo.submitForm()} />
                </>
              }
            />
          </div>

          <div className="painel-box">
            <div className="painel">
              <div className="aviso">
                <div className="titulo">Frota</div>
                <div className="texto">Sua frota inteira está aqui!</div>
                <div className="texto">
                  <ul>
                    <li>Histórico por Placa</li>
                    <li>Frequência de Abastecimento</li>
                    <li>Gráfico</li>
                    <li>Baixar em PDF e Excel</li>
                  </ul>
                </div>

                <div className="contato">
                  <div>Dúvidas entre em contato com o setor responsável:</div>
                  {isLoadingContato ? (
                    <Loading />
                  ) : (
                    dataItemsContato.map(item => (
                      <div key={item.nome} className="destaque">
                        <a href={`https://api.whatsapp.com/send?phone=55${item.zap}`} target="_blank" rel="noopener noreferrer nofollow">
                          {`${item.telefone} ${item.nome}`}
                        </a>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>

            <Form getApi={api => (this.placaApi = api)} onSubmit={this.handleSearchHistoricoPlaca}>
              <div className="box-historico">
                <div className="titulo">Minha Frota - Consulte por Placa</div>
                <div>
                  <RangePicker
                    field="datas"
                    onChange={evt => this.onChangeRangePicker(moment(evt[0]).format('YYYY-MM-DD'), moment(evt[1]).format('YYYY-MM-DD'))}
                    disabledDate={this.disabledDate}
                    disabled={isLoadingHistoricoPlaca}
                  />
                </div>
                <div className="placa">
                  <AntInput type="text" name="placa" maxLength={8} onBlur={evt => this.onChangePlaca(evt.target.value)} disabled={isLoadingHistoricoPlaca} />
                </div>

                <div className="titulo">Odômetro - Média por Placa</div>
                <div className="media">{isLoadingHistoricoPlaca ? <Loading /> : historicoMedia}</div>

                <div className="titulo">Histórico de Abastecimento</div>
                <div>
                  {isLoadingHistoricoPlaca ? (
                    <Loading />
                  ) : (
                    <ResponsiveContainer width="100%" height={200}>
                      <BarChart data={dadosAbastecimento} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="dia" />
                        <YAxis tickCount="7" ticks={ticks} />
                        <Tooltip
                          formatter={(value, name) => {
                            if (name === 'litros') return [`${value} L`, 'Litros'];
                            if (name === 'valor') return [`R$ ${value.toFixed(2)}`, 'Valor'];
                            return [value, name];
                          }}
                        />
                        <Bar dataKey="litros" fill="#8884d8" shape={this.TriangleBar} label={{ position: 'top' }}>
                          {dadosAbastecimento.map((entry, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <Cell key={`cell-${index}`} fill={colorsBars[index % 20]} />
                          ))}
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  )}
                </div>
              </div>
            </Form>
          </div>
          {/* FIM */}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ user }) => ({ user });

export default connect(mapStateToProps)(FrotaPage);
